import React from "react";
import { utils } from "zebulon-controls";
import { buildObject, exportFunctions as _exportFunctions
// aggregations
} from "./utils/utils";
// import { getFunction } from "./utils/compute.meta";
// ({row})=>accessor('qty')({row})*3
var functionToString = function functionToString(_ref) {
	var row = _ref.row;

	if (row.functionText) {
		return row.functionText;
	} else if (typeof row.functionJS === "function") {
		return String(row.functionJS);
	}
};
var stringToFunction = function stringToFunction(_ref2) {
	var row = _ref2.row,
	    status = _ref2.status,
	    meta = _ref2.meta,
	    utils_ = _ref2.utils_;

	var f = void 0;
	var accessors = meta.functions.filter(function (f) {
		return f.tp === "accessor";
	}).reduce(function (acc, f) {
		acc[f.id] = f.functionJS;
		return acc;
	}, {});
	var accessor = function accessor(_accessor) {
		return accessors[_accessor];
	};
	try {
		eval("f = " + row.functionText);
	} catch (e) {
		var error = status.errors.functionJS || {};
		error.JS = e.message;
		status.errors.functionJS = error;
	}
	if (typeof f === "function") {
		row.functionJS = f;
		// if (!functions[row.visibility]) {
		// 	functions[row.visibility] = {};
		// }
		// if (!functions[row.visibility][row.tp + "s"]) {
		// 	functions[row.visibility][row.tp + "s"] = {};
		// }
		// functions[row.visibility][row.tp + "s"][row.id] = f;
		if (status.errors.functionJS) {
			delete status.errors.functionJS.JS;
		}
	} else {
		var _error = status.errors.functionJS || {};
		_error.JS = "function not evaluated";
		status.errors.functionJS = _error;
	}
	return true;
};
export var onNext = function onNext(data, message) {
	var indexedColumn = message.meta.table.rowId || message.meta.table.primaryKey;
	data.forEach(function (row) {
		//  a voir deleted row on server side + conflict (zebulon table) => recreation of the row (new_=true) index_=...
		if (message.index) {
			var index = message.index[row[indexedColumn]];
			if (index !== undefined) {
				row.index_ = index;
				var status = message.updatedRows[index];
				if (status) {
					status.row = row;
				} else {
					message.data[index] = row;
				}
			} else {
				message.index[row[message.meta.table.primaryKey]] = message.data.length;
				message.data.push(row);
			}
		} else {
			message.data.push(row);
		}
	});
};
export var onCompleted = function onCompleted(message) {};
export var onError = function onError(e, message) {};
// export const accessor = accessor => {
// 	return () => 4;
// };
var isLocal = function isLocal(_ref3) {
	var row = _ref3.row,
	    status = _ref3.status;
	return (status || {}).new_ || row.isLocal;
};
var functions = {
	properties: {
		accessors: {
			propertyType: function propertyType(_ref4) {
				var row = _ref4.row,
				    status = _ref4.status,
				    meta = _ref4.meta;

				// if (row.tp) {
				// 	return row.tp;
				// } else
				if (row.reference) {
					return row.reference;
					// 	return typeof row.foreignObject === "string"
					// 		? row.foreignObject
					// 		: row.foreignObject.name;
					// } else if (
					// 	row.primaryKeyAccessor &&
					// 	row.setForeignKeyAccessor
					// ) {
					// 	if (!row.reference) {
					// 		return "Joined object";
					// 	} else {
					// 		return `${row.reference} key`;
					// 	}
				} else if (row.aggregation) {
					return "analytic";
				} else if (row.accessor || (status || {}).new_) {
					return "computed";
				} else {
					return "dataset";
				}
			}
		},
		sorts: {},
		formats: {
			isArrayOrFunction: function isArrayOrFunction(_ref5) {
				var value = _ref5.value;

				if (typeof value === "function" || Array.isArray(value)) {
					return React.createElement(
						"div",
						{
							style: {
								backgroundColor: "#f5f7da",
								fontStyle: "italic"
							}
						},
						Array.isArray(value) ? "array[]" : "fct()"
					);
				}
				return value;
			}
		},
		aggregations: {},
		selects: {},
		validators: {
			row: function row(_ref6) {
				var _row = _ref6.row,
				    status = _ref6.status,
				    data = _ref6.data,
				    params = _ref6.params;
			}
		},
		editables: {
			isDataset: function isDataset(_ref7) {
				var row = _ref7.row;
				return row.tp === "Dataset";
			},
			isNotDataset: function isNotDataset(_ref8) {
				var row = _ref8.row;
				return row.tp !== "Dataset";
			},
			isAnalytic: function isAnalytic(_ref9) {
				var row = _ref9.row;
				return row.tp === "Analytic";
			}
		},
		defaults: {},
		row: function row() {},
		table: function table() {},
		actions: {
			exportMeta: function exportMeta(_ref10) {
				var meta = _ref10.meta;
				return "meta = " + JSON.stringify(buildObject(meta));
			}
		}
	},
	functions: {
		accessors: {
			functionToString: functionToString,
			functionDescriptor: function functionDescriptor(_ref11) {
				var row = _ref11.row;

				var label = void 0;
				if (row.tp === "accessor") {
					label = "Parameters: ({row,status,data,params,utils})";
				} else if (row.tp === "editable") {
					label = "Parameters: ({row,status,data,params})";
				} else if (row.tp === "select") {
					label = "Parameters: ({row,status,data,params})";
				} else if (row.tp === "validator") {
					label = "Parameters: ({row,status,data,params})";
				} else if (row.tp === "format") {
					label = "Parameters: (value,row,status,data,params)";
				} else if (row.tp === "aggregation") {
					label = "Parameters: ([values])";
				} else if (row.tp === "sort") {
					label = "Parameters: (rowA, rowB)";
				} else if (row.tp === "window") {
					label = "Parameters: (value)";
				}
				return (row.caption || row.id) + " : " + label;
			},
			isLocal: isLocal
		},
		validators: {
			stringToFunction: stringToFunction
		},
		actions: {
			exportFunctions: function exportFunctions(_ref12) {
				var data = _ref12.data;
				return "functions = " + _exportFunctions(data);
			}
		},
		editables: { isLocal: isLocal }
	},
	dimensions: {
		accessors: {
			sortAcc: function sortAcc(_ref13) {
				var row = _ref13.row;
				return (row.sort || {}).keyAccessor;
			},
			sortFct: function sortFct(_ref14) {
				var row = _ref14.row;
				return (row.sort || {}).custom;
			},
			isLocal: isLocal
		},
		validators: {
			sortAcc: function sortAcc(_ref15) {
				var row = _ref15.row;
				return row.sort = Object.assign({}, row.sort || {}, {
					keyAccessor: row.sortAccessor
				});
			},
			sortFct: function sortFct(_ref16) {
				var row = _ref16.row;
				return row.sort = Object.assign({}, row.sort || {}, {
					custom: row.sortFunction
				});
			}
		},
		editables: {
			isLocal: isLocal
		}
	},

	measures: {
		accessors: {
			isLocal: isLocal
		},
		editables: {
			isLocal: isLocal
		}
	},
	globals_: {
		editables: {
			is_selected: function is_selected(_ref17) {
				var row = _ref17.row;
				return row.index_ !== undefined;
			},
			is_new: function is_new(_ref18) {
				var status = _ref18.status;
				return status.new_;
			}
		},
		observers: {
			onNext: onNext,
			onCompleted: onCompleted,
			onError: onError
		}
	}
};

export { functions };
export var setPropertyAccessors = function setPropertyAccessors(properties, data) {
	var accessors = {};
	properties.forEach(function (property) {
		accessors[property.id] = {
			id: "row." + property.id,
			caption: "row." + property.id,
			type: "property"
		};
		if (data && (property.dataType === "object" || property.dataType === "joined object")) {
			data.forEach(function (row) {
				if (!utils.isNullValue(row[property.id])) {
					Object.keys(row[property.id]).forEach(function (key) {
						accessors[property.id + "." + key] = {
							id: "row." + property.id + "." + key,
							caption: "row." + property.id + "." + key,
							type: "object property"
						};
					});
				}
			});
		}
	});
	propertyAccessors = accessors;
};
var propertyAccessors = {};

export var metaDescriptions = function metaDescriptions(object)
// ,
// properties,
// data_
{
	var callbacks = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	var functions = arguments[2];

	var f = functions;
	var getFunctions = function getFunctions(type) {
		var obj = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : object;

		return f.filter(function (f) {
			return f.tp === type;
		}).reduce(function (acc, f) {
			acc[f.id] = {
				id: f.id,
				caption: f.caption || f.id,
				type: "function",
				style: { color: "blue" }
			};
			return acc;
		}, {});
	};
	var getAccessorsAndProperties = function getAccessorsAndProperties(obj) {
		return function () {
			var dataAccessors = propertyAccessors;
			var accessors = getFunctions("accessor", obj);
			// console.log("getAccessorsAndProperties", accessors, dataAccessors);
			return Object.assign({}, dataAccessors, accessors);
		};
	};
	var getAggregations = function getAggregations(obj) {
		return function () {
			return getFunctions("aggregation", obj);
		};
	};
	var getFormats = function getFormats(obj) {
		return function () {
			return getFunctions("format", obj);
		};
	};
	var getSorts = function getSorts(obj) {
		return function () {
			return getFunctions("sort", obj);
		};
	};
	var getWindowFunctions = function getWindowFunctions(obj) {
		return function () {
			return getFunctions("window", obj);
		};
	};
	var getSelects = function getSelects(obj) {
		return function () {
			return getFunctions("select", obj);
		};
	};
	var getValidators = function getValidators(obj) {
		return function () {
			return getFunctions("validator", obj);
		};
	};
	// const getEditables = obj => () => getFunctions("editable", obj);
	var getDefaults = function getDefaults(obj) {
		return function () {
			return getFunctions("default", obj);
		};
	};
	var getForeignObjects = function getForeignObjects(obj) {
		return function () {
			return getFunctions("foreignObject", obj);
		};
	};
	if (object === "dataset") {
		return {
			table: {
				object: "dataset",
				editable: true,
				noFilter: false,
				// caption: "Dataset",
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "is_selected",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Save",
					enable: true,
					key: "f12"
				}, {
					type: "refresh",
					caption: "Refresh",
					enable: true,
					key: "10"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: {},
			properties: []
		};
	} else if (object === "properties") {
		return {
			table: {
				object: object,
				editable: true,
				primaryKey: "id",
				code: "caption",
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isNotDataset",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
					// ,
					// {
					// 	type: "detail",
					// 	caption: "Analytic",
					// 	enable: "isAnalytic",
					// 	content: Property
					// }
					// {
					// 	type: "action",
					// 	caption: "Apply",
					// 	action: callbacks.applyMeta,
					// 	enable: true
					// }
					// ,
					// {
					// 	type: "action",
					// 	caption: "Export configuration",
					// 	action: "exportMeta",
					// 	enable: true
					// }
				}]
			},
			row: {
				// validator: "propertyValidator",
				// detail: "propertyDetail"
			},
			properties: [{
				id: "id",
				caption: "Column",
				width: 100,
				dataType: "string",
				editable: "isNotDataset",
				mandatory: true,
				locked: true
			}, {
				id: "tp",
				caption: "Type",
				width: 150,
				dataType: "string",
				editable: false,
				default: "Computed",
				accessor: "propertyType",
				filterType: "values"
			}, {
				id: "dataType",
				caption: "Data type",
				width: 100,
				dataType: "string",
				editable: "isNotDataset",
				filterType: "values",
				select: ["number", "string", "text", "date", "boolean", "object", "joined object"]
			}, {
				id: "caption",
				caption: "Caption",
				width: 150,
				dataType: "string",
				editable: true
			}, {
				id: "editable",
				caption: "Editable",
				width: 80,
				dataType: "boolean",
				editable: true,
				default: false
			}, {
				id: "mandatory",
				caption: "Mandatory",
				width: 90,
				dataType: "boolean",
				editable: true,
				default: true
			}, {
				id: "hidden",
				caption: "Hidden",
				width: 80,
				dataType: "boolean",
				editable: true,
				default: false
			}, {
				id: "width",
				caption: "Width",
				width: 60,
				dataType: "number",
				editable: true,
				default: 100
			}, {
				id: "format",
				caption: "Format",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getFormats("dataset")
			}, {
				id: "filterType",
				caption: "Filter",
				width: 100,
				dataType: "string",
				editable: true,
				select: ["starts", "starts (case sensitive)", "contains", "=", ">=", "<=", "between", "values"]
			},

			// only for new properties
			{
				id: "accessor",
				caption: "Accessor",
				width: 150,
				dataType: "string",
				editable: "isNotDataset",
				hidden: false,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "select",
				caption: "Select",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getSelects("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "default",
				caption: "Default",
				width: 100,
				dataType: "string",
				editable: true,
				// hidden: true,
				filterType: "values",
				select: getDefaults("dataset")
			}, {
				id: "foreignObject",
				caption: "Foreign object",
				width: 150,
				dataType: "string",
				editable: true,
				// hidden: true,
				// filterType: "values",
				select: getForeignObjects("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "onChange",
				caption: "On change",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getValidators("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "onCellQuit",
				caption: "On cell quit",
				width: 100,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getValidators("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "groupByAccessor",
				caption: "Group by accessor",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "sortAccessor",
				caption: "Sort accessor",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "aggregation",
				caption: "Aggregation",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAggregations("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "comparisonAccessor",
				caption: "Comparison accessor",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "startFunction",
				caption: "Start function",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getWindowFunctions("dataset"),
				format: "isArrayOrFunction"
			}, {
				id: "endFunction",
				caption: "End function",
				width: 200,
				dataType: "string",
				editable: true,
				hidden: true,
				filterType: "values",
				select: getWindowFunctions("dataset"),
				format: "isArrayOrFunction"
			}]
		};
	} else if (object === "functions") {
		return {
			table: {
				object: object,
				editable: true,
				primaryKey: "id",
				code: "caption",
				onSave: callbacks.applyFunctions,
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isLocal",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Apply",
					enable: true,
					hidden: !callbacks.applyFunctions,
					key: "f12"
				},, {
					type: "action",
					caption: "Export functions",
					action: "exportFunctions",
					hidden: true
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: { descriptor: "functionDescriptor" },
			properties: [{
				id: "id",
				caption: "Code",
				width: 100,
				dataType: "string",
				editable: "isLocal",
				mandatory: true,
				locked: true
			}, {
				id: "caption",
				caption: "Caption",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "between"
			}, {
				id: "visibility",
				caption: "Visibility",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				select: ["", "dataset", "properties", "functions", "global"],
				filterType: "values",
				mandatory: true,
				default: "global"
			}, {
				id: "tp",
				caption: "Type",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				filterType: "values",
				select: ["", "action", "accessor", "aggregation", "format", "sort", "window", "select", "validator", "editable", "default", "descriptor", "dml"]
			}, {
				id: "isLocal",
				caption: "Local",
				accessor: "isLocal",
				width: 80,
				dataType: "boolean",
				default: true
			}, {
				id: "functionText",
				caption: "Function",
				accessor: "functionToString",
				onQuit: "stringToFunction",
				width: 500,
				dataType: "text",
				editable: "isLocal"
			}, {
				id: "functionJS",
				caption: "Function",
				// accessor: "functionToString",
				// onQuit: "stringToFunction",
				hidden: true
			}]
		};
	} else if (object === "measures") {
		return {
			table: {
				object: "measures",
				editable: true,
				primaryKey: "id",
				code: "caption",
				onSave: callbacks.applyMeasures,
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isLocal",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Apply",
					// action: callbacks.applyMeasures,
					enable: true,
					key: "f12"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: {},
			properties: [{
				id: "id",
				caption: "id",
				width: 100,
				dataType: "string",
				editable: "isLocal",
				mandatory: true
			}, {
				id: "caption",
				caption: "caption",
				width: 150,
				dataType: "string",
				editable: true
			}, {
				id: "valueAccessor",
				caption: "Value accessor",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				mandatory: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "format",
				caption: "format",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getFormats("dataset")
			}, {
				id: "aggregation",
				caption: "aggregation",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				mandatory: true,
				default: "sum",
				filterType: "values",
				select: getAggregations("dataset")
			}, {
				id: "isLocal",
				caption: "Local",
				accessor: "isLocal",
				width: 80,
				dataType: "boolean",
				default: true
			}]
		};
	} else if (object === "dimensions") {
		return {
			table: {
				object: object,
				editable: true,
				primaryKey: "id",
				code: "caption",
				onSave: callbacks.applyDimensions,
				actions: [{
					type: "insert",
					caption: "New",
					enable: true,
					key: "f2"
				}, {
					type: "delete",
					caption: "Delete",
					enable: "isLocal",
					key: "f3"
				}, {
					type: "duplicate",
					caption: "Duplicate",
					enable: "is_selected",
					key: "f4"
				}, {
					type: "save",
					caption: "Apply",
					// action: callbacks.applyDimensions,
					enable: true,
					key: "f12"
				}, {
					type: "action",
					enable: true,
					hidden: true,
					action: "toggleFilter",
					key: "f11"
				}]
			},
			row: {},
			properties: [{
				id: "id",
				caption: "Dimension",
				width: 100,
				dataType: "string",
				editable: "isLocal"
			}, {
				id: "caption",
				caption: "Caption",
				width: 150,
				dataType: "string",
				editable: true
			}, {
				id: "keyAccessor",
				caption: "Key accessor",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				filterType: "values",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "labelAccessor",
				caption: "Label accessor",
				width: 150,
				dataType: "string",
				editable: "isLocal",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "sort",
				caption: "sort",
				width: 100,
				dataType: "object",
				hidden: true,
				editable: true
			}, {
				id: "sortAccessor",
				accessor: "sortAcc",
				onQuit: "sortAcc",
				caption: "Sort accessor",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getAccessorsAndProperties("dataset")
			}, {
				id: "sortFunction",
				accessor: "sortFct",
				onQuit: "sortFct",
				caption: "Sort function",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getSorts("dataset")
			}, {
				id: "format",
				caption: "format",
				width: 150,
				dataType: "string",
				editable: true,
				filterType: "values",
				select: getFormats("dataset")
			}, {
				id: "isLocal",
				caption: "Local",
				accessor: "isLocal",
				width: 80,
				dataType: "boolean",
				default: true
			}]
		};
	}
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/zebulon-table/lib/MetaDescriptions.js
// module id = 63
// module chunks = 0